import Plugin from '@swup/plugin';

export default class BoneCustomSwupUpdater extends Plugin {

	constructor(options) {
		super();

		this.name = 'BoneCustomSwupUpdater';
	}

	mount() {
		this.swup.on('contentReplaced', () => {
			const page = this.swup.cache.getCurrentPage();
			if (!page || !page.originalContent) {
				return;
			}

			this.updatePageTheme(page.originalContent);
		});
	}

	/**
	 *
	 * @param {string} pageContent
	 */
	updatePageTheme(pageContent) {
		// NOTE: named group throws a parsing error even though it's valid
		// const matches = pageContent.match(/<html .*?data-theme="(?<theme>.*?)">/i);
		// if (matches &&
		// 	matches.groups &&
		// 	matches.groups.theme
		// 	) {
		// 	document.documentElement.dataset.theme = matches.groups.theme;
		// }

		const themeMatches = pageContent.match(/<html .*?data-theme="(.*?)".*>/);
		if (themeMatches && themeMatches.length >= 2) {
			document.documentElement.dataset.theme = themeMatches[1];
		}

		const seasonMatches = pageContent.match(/<html .*?data-season="(.*?)".*>/);
		if (seasonMatches && seasonMatches.length >= 2) {
			document.documentElement.dataset.season = seasonMatches[1];
		}
	}
}



// WEBPACK FOOTER //
// ./scripts/modules/bone-custom-swup-updater.js